import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { setUnauthorizedHandler } from './api/client';
import { AppLayout } from './components/layout/AppLayout';
import { RequireAuth } from './components/RequireAuth';
import { LoginPage } from './pages/LoginPage';
import { AdminActivityPage } from './pages/admin/AdminActivityPage';
import { AdminSecretsPage } from './pages/admin/AdminSecretsPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { CharactersPage } from './pages/characters/CharactersPage';
import { CutPage } from './pages/cut/CutPage';
import { LibraryPage } from './pages/library/LibraryPage';
import { PlacementPage } from './pages/placement/PlacementPage';
import { FontsPage } from './pages/fonts/FontsPage';
import { PromptsPage } from './pages/prompts/PromptsPage';
import { SubtitlesPage } from './pages/subtitles/SubtitlesPage';
import { VideoGenPage } from './pages/videogen/VideoGenPage';
import { TranslatePage } from './pages/translate/TranslatePage';
import { TtsPage } from './pages/tts/TtsPage';
import { VoicesPage } from './pages/voices/VoicesPage';

export function App() {
  const navigate = useNavigate();

  useEffect(() => {
    setUnauthorizedHandler(() => {
      const from = window.location.pathname + window.location.search;
      if (window.location.pathname !== '/login') {
        navigate('/login', { replace: true, state: { from } });
      }
    });
    return () => setUnauthorizedHandler(null);
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/tts" replace />} />

        <Route path="/tts" element={<TtsPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/placement" element={<PlacementPage />} />
        <Route path="/cut" element={<CutPage />} />
        <Route path="/characters" element={<CharactersPage />} />
        <Route path="/prompts" element={<PromptsPage />} />
        <Route path="/fonts" element={<FontsPage />} />
        <Route path="/translate" element={<TranslatePage />} />
        <Route path="/subtitles" element={<SubtitlesPage />} />
        <Route path="/video-gen" element={<VideoGenPage />} />
        <Route path="/voices" element={<VoicesPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
        <Route path="/admin/settings" element={<AdminSecretsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/tts" replace />} />
    </Routes>
  );
}
